import { render, staticRenderFns } from "./IndicatorsEdition.vue?vue&type=template&id=be15f8e0&scoped=true&"
import script from "./IndicatorsEdition.vue?vue&type=script&lang=js&"
export * from "./IndicatorsEdition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be15f8e0",
  null
  
)

export default component.exports